import { pageSelectorGenerator } from '@test/pageSelectors';

export const GiftAmountSelectors = pageSelectorGenerator('GiftAmount', ['ContainerElement', 'GiveNowButton', 'AmountInput']);
